// Simple Fuzzy Match impl.
// Tests if non-space characters in `searchStr` occur in `testStr` in the same order.
// Returns 0 if there is no match, or a positive number if there is a match; the
// number is the "strength" of the match.
// This is fine to live on the front end even though it's not very optimized, since
// we are searching at most 100 strings.
export const fuzzyMatch = (testStr: string, searchStr: string): number => {
  testStr = testStr.toLowerCase();
  searchStr = searchStr.toLowerCase();

  let score = 1;
  let testIndex = 0;
  for (let i = 0; i < searchStr.length; i++) {
    // Ignore all spaces in the search string
    if (!searchStr[i].match(/\s/)) {
      const tempIndex = testStr.indexOf(searchStr[i], testIndex);
      if (tempIndex === -1) {
        return 0;
      }
      if (tempIndex === testIndex) {
        // Successive characters matching in a row means a closer match
        score += 1;
      }
      testIndex = tempIndex + 1;
    }
  }

  return score;
};
